import { getSchedulerDataServicesInstall } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"


export function heatingCoolingInstallation() {
  let servicesStart = [
    {
      id: "Cooling",
      label: <>Cooling</>,
      data: [
        [
          {
            name: "isCoolingProperly",
            question: "Is your current system cooling properly?",
            answers: [
              {
                id: "Yes",
                label: <>Yes</>,
                value: "Yes",  
                jobType: "HVAC Install Estimate",
                remType: "estimate"
              },
              {
                id: "No",
                label: <>No</>,
                value: "No",
                jobType: "HVAC Install Estimate",
                remType: "estimate"
              },
            ],
          },
          {
            name: "equipmentAge",
            question: "How old is your equipment?",
            answers: [
              {
                id: "0-5 Years",
                label: <>0-5 Years</>,
                value: "0-5 Years",
              },
              {
                id: "6-10 Years",
                label: <>6-10 Years</>,
                value: "6-10 Years",
              },
              {
                id: "11+ Years",
                label: <>11+ Years</>,
                value: "11+ Years",
              },
              {
                id: "Not Sure",
                label: <>Not Sure</>,
                value: "Not Sure",
              },
            ],
          },
        ],
        [
          {
            name: "How-soon-to-installed",
            question: "How soon are you looking to have new equipment installed?",
            answers: [
              {
                id: "This week",
                label: <>This week</>,
                value: "This week",
              },
              {
                id: "Within 30 Days",
                label: <>Within 30 Days</>,
                value: "Within 30 Days",
              },
              {
                id: "Unsure",
                label: <>Unsure</>,
                value: "Unsure",
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Heating",
      label: <>Heating</>,
      data: [
        [
          {
            name: "isCoolingProperly",
            question: "Is your current system heating properly?",
            answers: [
              {
                id: "Yes",
                label: <>Yes</>,
                value: "Yes",
                jobType: "HVAC Install Estimate",
                remType: "estimate"
              },
              {
                id: "No",
                label: <>No</>,
                value: "No",
                jobType: "HVAC Install Estimate",
                remType: "estimate"
              },
            ],
          },
          {
            name: "equipmentAge",
            question: "How old is your equipment?",
            answers: [
              {
                id: "0-5 Years",
                label: <>0-5 Years</>,
                value: "0-5 Years",
              },
              {
                id: "6-10 Years",
                label: <>6-10 Years</>,
                value: "6-10 Years",
              },
              {
                id: "11+ Years",
                label: <>11+ Years</>,
                value: "11+ Years",
              },
              {
                id: "Not Sure",
                label: <>Not Sure</>,
                value: "Not Sure",
              },
            ],
          },
        ],
        [
          {
            name: "How-soon-to-installed",
            question: "How soon are you looking to have new equipment installed?",
            answers: [
              {
                id: "This week",
                label: <>This week</>,
                value: "This week",
              },
              {
                id: "Within 30 Days",
                label: <>Within 30 Days</>,
                value: "Within 30 Days",
              },
              {
                id: "Unsure",
                label: <>Unsure</>,
                value: "Unsure",
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Full System",
      label: <>Full System</>,
      data: [
        [
          {
            name: "isCoolingProperly",
            question: "Is your current system working properly?",
            answers: [
              {
                id: "Yes",
                label: <>Yes</>,
                value: "Yes",
                jobType: "HVAC Install Estimate",
                remType: "estimate"
              },
              {
                id: "No",
                label: <>No</>,
                value: "No",
                jobType: "HVAC Install Estimate",
                remType: "estimate"
              },
            ],
          },
          {
            name: "equipmentAge",
            question: "How old is your equipment?",
            answers: [
              {
                id: "0-5 Years",
                label: <>0-5 Years</>,
                value: "0-5 Years",
              },
              {
                id: "6-10 Years",
                label: <>6-10 Years</>,
                value: "6-10 Years",
              },
              {
                id: "11+ Years",
                label: <>11+ Years</>,
                value: "11+ Years",
              },
              {
                id: "Not Sure",
                label: <>Not Sure</>,
                value: "Not Sure",
              },
            ],
          },
        ],
        [
          {
            name: "How-soon-to-installed",
            question: "How soon are you looking to have new equipment installed?",
            answers: [
              {
                id: "This week",
                label: <>This week</>,
                value: "This week",
              },
              {
                id: "Within 30 Days",
                label: <>Within 30 Days</>,
                value: "Within 30 Days",
              },
              {
                id: "Unsure",
                label: <>Unsure</>,
                value: "Unsure",
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Thermostats",
      label: <>Thermostats</>,
      jobType: "Thermostat",
      data: [],
    },
    {
      id: "Water Heaters",
      label: <>Water Heaters</>,
      data: [
        [
          {
            name: "equipmentType",
            question: "What kind of water heater do you have?",
            answers: [
              {
                id: "Regular Tank",
                label: <>Regular Tank</>,
                value: "Regular Tank",
                jobType: "Tankless Water Heater: Non-Member",
                remType: "estimate"
              },
              {
                id: "Tankless",
                label: <>Tankless</>,
                value: "Tankless Water Heater",
                jobType: "Tankless Water Heater: Non-Member",
                remType: "estimate"
              },
            ],
          },
          {
            name: "equipmentAge",
            question: "How old is your equipment?",
            answers: [
              {
                id: "0-5 Years",
                label: <>0-5 Years</>,
                value: "0-5 Years",
              },
              {
                id: "6-10 Years",
                label: <>6-10 Years</>,
                value: "6-10 Years",
              },
              {
                id: "11+ Years",
                label: <>11+ Years</>,
                value: "11+ Years",
              },
              {
                id: "Not Sure",
                label: <>Not Sure</>,
                value: "Not Sure",
              },
            ],
          },
        ],
        [
          {
            name: "How-soon-to-installed",
            question: "How soon are you looking to have new equipment installed?",
            answers: [
              {
                id: "This week",
                label: <>This week</>,
                value: "This week",
              },
              {
                id: "Within 30 Days",
                label: <>Within 30 Days</>,
                value: "Within 30 Days",
              },
              {
                id: "Unsure",
                label: <>Unsure</>,
                value: "Unsure",
              },
            ],
          },
        ],
      ],
    },
  ];
  const jobTypeFilter = getSchedulerDataServicesInstall// Replace with the desired job type to filter

  return filteredServicesComponents(servicesStart, jobTypeFilter);

}